<classic-content-wrapper
  [attr.show-content]="showContent$ | async"
  [attr.route]="routeForV1"
  [attr.login-state]="loginState"
  [attr.auth-input-event]="authInputEvent"
  [attr.clear-cart]="cartRefresh"
  [attr.support-number]="supportNumber"
  [attr.open-chat]="openChat"
  (loading)="handleLoading($any($event))"
  (authOutputEvent)="handleAuthOutputEvent($any($event))"
  (loginChanged)="handleloginChanged($any($event))"
  (routeChange)="handleRouteChange($any($event))"
  (cartChange)="handleCartChange($any($event))"
  (supportNumberChange)="handleSupportNumberChange($any($event))"
  (addressLookupPrepopChange)="handleAddressLookupPrepopChange($any($event))"
  (prerenderReady)="handlePrerenderReady($any($event))"
  (notificationStateChanged)="handleNotificationStateChanged($any($event))"
>
</classic-content-wrapper>
